import React from "react";

import { css } from "@codemirror/lang-css";
import { html } from "@codemirror/lang-html";
import { javascript } from "@codemirror/lang-javascript";
import { json } from "@codemirror/lang-json";
import { LanguageSupport } from "@codemirror/language";
import { EditorView } from "@codemirror/view";
import CodeMirror, { ReactCodeMirrorProps } from "@uiw/react-codemirror";

export interface IgCodeEditorProps extends ReactCodeMirrorProps {
  language: "html" | "css" | "js" | "json";
  fontSize?: string;
}

export const IgCodeEditor = (props: IgCodeEditorProps) => {
  const { language, fontSize = "13px", ...rest } = props;

  const theme = EditorView.baseTheme({
    "&": {
      fontSize: fontSize,
    },
  });

  let langExt: LanguageSupport;
  switch (language) {
    case "html":
      langExt = html();
      break;
    case "css":
      langExt = css();
      break;
    case "js":
      langExt = javascript();
      break;
    case "json":
      langExt = json();
      break;
  }

  return (
    <CodeMirror
      {...rest}
      indentWithTab={true}
      extensions={[theme, langExt, EditorView.lineWrapping]}
    />
  );
};
